import React, { useState, useEffect } from 'react';
import { getActivationURL } from '../../Services/getActivationURL';
import NetflixError from './NetflixError';
import { translations } from '../Text/translations';

const NetflixNotActivated = ({ currentLang, nickname, mobilenowid, emailnowid, fsa, fsaType }) => {
  const [responseError, setResponseError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleActivateButtonClick = () => {
    if (!loading) {
      setLoading(true);
      Promise.all([
        getActivationURL('NETFLIX')
      ]).then(([activationResponse]) => {
        if (activationResponse.url) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'partner': 'netflix',
            'fsa_type': (fsaType || '').toLowerCase(),
            'click_location': 'partner_landing_page',
            'event': 'partner_activation_click'
          });
          window.location.href = activationResponse.url;
          setLoading(false);
        } else {
          setResponseError(true);
          setLoading(false);
        }
      }).catch((error) => {
        setResponseError(true);
        setLoading(false);
      });
    }
  };
  return (
    <>
      {responseError && (
        <NetflixError
          currentLang={currentLang}
          nickname={nickname}
          mobilenowid={mobilenowid}
          emailnowid={emailnowid}
          fsa={fsa}
        />
      )}
      {!responseError && (
        <>
          <div className="message">
            <h4>{translations[currentLang].netflixSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].netflixSubjectGreeting2}</h4>
            <p>{translations[currentLang].netflixNotActivated}</p>
            <p>{translations[currentLang].netflixActivateNowRemark}</p>
          </div>
          <div className="cta-buttons">
            <button className="btn primary" onClick={handleActivateButtonClick}>
              {translations[currentLang].netflixActivateNow}
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default NetflixNotActivated;